(function($){
    var $fn = $(".comp_slider");
    if($fn.length){
        var $slider = $fn.find("[data-slider]"),
            $slider_caption = $fn.find("[data-slider-caption]"),
            $autoplay = ($slider.attr("data-autoplay")),
            $autoplay_speed = ($autoplay)?$slider.data("autoplay"):0;

        if ($slider.children().length > 1) {
            $slider.slick({
                accessibility: false,
                infinite: true,
                speed: 500,
                fade: false,
                cssEase: 'linear',
                autoplay: $autoplay,
                autoplaySpeed: $autoplay_speed,
                arrows: true,
                prevArrow: "<a class='slick-prev slick-arrow icon--chevron-left'></a>",
                nextArrow: "<a class='slick-next slick-arrow icon--chevron-right'></a>",
                pauseOnHover: false,
                asNavFor: $slider_caption,
                dots: false,
            });
        }

        if ($slider_caption.children().length > 1) {
            $slider_caption.slick({
                accessibility: false,
                infinite: true,
                speed: 500,
                fade: false,
                cssEase: 'linear',
                arrows: false,
                dots: false,
                asNavFor: $slider,
                adaptiveHeight: true,
                focusOnSelect: false
            });
        }
    }
})(jQuery);